// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"checkInByReserve_pageContainer__3idr6","noticeWrapper":"checkInByReserve_noticeWrapper__1Ejwu","mainContent":"checkInByReserve_mainContent__294r7"};